(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[482],{

/***/ 41619:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CertificationProductsListing"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderby"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"MENU_ORDER"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"excerpt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"srcSet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SimpleProduct"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"productId"},"name":{"kind":"Name","value":"databaseId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onSale"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salePrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":526}};
    doc.loc.source = {"body":"query CertificationProductsListing {\n  certifications(where: { orderby: { field: MENU_ORDER, order: ASC } }) {\n    nodes {\n      id\n      title\n      excerpt\n      uri\n      featuredImage {\n        node {\n          title\n          srcSet\n          sourceUrl\n        }\n      }\n      info {\n        product {\n          ... on SimpleProduct {\n            id\n            productId: databaseId\n            name\n            onSale\n            price\n            salePrice\n            status\n          }\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.CertificationProductsListing = oneQuery(doc, "CertificationProductsListing");
        


/***/ }),

/***/ 92711:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificaciones",
      function () {
        return __webpack_require__(29849);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(36268);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85942);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12556);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80270);
/* harmony import */ var _components_LoadingIndicator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83411);
/* harmony import */ var _components_ShoppingCart__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94676);
/* harmony import */ var _components_Toaster__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88675);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(471);
/* harmony import */ var _components_ProtectedPage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26212);
/* harmony import */ var _graphql_queries_certificationProductsListing_graphql__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41619);
/* harmony import */ var _graphql_queries_certificationProductsListing_graphql__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_graphql_queries_certificationProductsListing_graphql__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86010);

















function CertificationsPageSkeletonItem() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "shadow rounded-lg lg:rounded-xl overflow-hidden bg-white md:col-span-6 flex ring-1 ring-black ring-opacity-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-stretch w-full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-40 bg-gray-100 animate-pulse"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex-1 flex flex-col p-4 lg:p-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col space-y-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-6 w-11/12 bg-gray-100 animate-pulse"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-6 w-9/12 bg-gray-100 animate-pulse"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-6 bg-gray-100 animate-pulse w-32"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "space-y-4 py-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col space-y-2 flex-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-2.5 bg-gray-100 animate-pulse"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-2.5 bg-gray-100 animate-pulse w-11/12"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-2.5 bg-gray-100 animate-pulse w-10/12"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-2.5 bg-gray-100 animate-pulse w-9/12"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "h-2.5 bg-gray-100 animate-pulse w-8/12"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-4 bg-gray-100 animate-pulse w-20"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-px bg-gray-100 animate-pulse w-full"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center pt-4",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex-1 flex items-center justify-end space-x-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-8 w-28 bg-gray-100 animate-pulse rounded-full"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-8 w-28 bg-gray-100 animate-pulse rounded-full"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function CertificationsPageSkeleton() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex w-full py-10 lg:pb-20 bg-gray-100 from-gray-100 to-white relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: "space-y-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "text-3xl lg:text-5xl font-display font-extrabold tracking-tight",
                        children: "Certificaciones"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-12 gap-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CertificationsPageSkeletonItem, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CertificationsPageSkeletonItem, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CertificationsPageSkeletonItem, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CertificationsPageSkeletonItem, {})
                    ]
                })
            ]
        })
    });
}
var isDevelopment = "production" !== "production";
function CertificationsPageError(param) {
    var error = param.error;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex w-full py-10 lg:pb-20 relative bg-gray-100 from-gray-100 to-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: "relative z-20 space-y-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "text-3xl lg:text-5xl font-display font-extrabold tracking-tight",
                        children: "Certificaciones"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col space-y-4",
                    children: error.graphQLErrors.map(function(err, idx) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "bg-red-50 rounded ring-1 ring-red-400 shadow flex flex-col overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "px-4 py-2 flex items-start space-x-1.5 rounded",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            className: "h-5 w-5 text-red-500 mt-px",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                fillRule: "evenodd",
                                                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                                                clipRule: "evenodd"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "font-medium flex-1",
                                            children: err.message
                                        })
                                    ]
                                }),
                                isDevelopment && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "border-t border-red-300 bg-white px-4 py-2 flex flex-col",
                                    children: err.debugMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-semibold leading-4 text-sm",
                                                children: "Mensaje de depuraci\xf3n:"
                                            }),
                                            "\xa0\xa0",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-mono text-sm pt-0.5",
                                                children: err.debugMessage
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, "graphql-error-".concat(idx));
                    })
                })
            ]
        })
    });
}
CertificationsPageError.propTypes = {
    error: prop_types__WEBPACK_IMPORTED_MODULE_2___default().shape({
        message: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
    }).isRequired
};
function CertificationsPageItem(param) {
    var certification = param.certification, product = param.product, isAuthenticated = param.isAuthenticated, apolloClient = param.apolloClient;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), qty = ref[0], setItemQuantity = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), initialQuantity = ref1[0], setInitialQuantity = ref1[1];
    var cart = (0,_components_ShoppingCart__WEBPACK_IMPORTED_MODULE_7__/* .useCart */ .jD)();
    var onAddItemToCartClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var quantity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        if (!isAuthenticated) {
            // Add to cart is only allowed for authenticated users
            return;
        }
        if (quantity < 1) {
            notifyError("Debe indicar la cantidad de unidades ".concat(product.name, " que desea a\xf1adir al carrito."));
            return;
        }
        setInitialQuantity(quantity);
        if (cart.isEmpty || !cart.inCart(product.productId)) {
            cart.addItem((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, product), {
                id: product.productId
            }), quantity, apolloClient, function() {
                (0,_components_Toaster__WEBPACK_IMPORTED_MODULE_8__/* .notifySuccess */ .t5)(quantity === 1 ? "Se ha a\xf1adido al carrito una unidad de ".concat(product.name, ".") : "Se han a\xf1adido al carrio ".concat(quantity, " unidades de ").concat(product.name, "."));
                setInitialQuantity(1);
            });
        } else {
            var itm = cart.getItem(product.productId);
            if (itm) {
                var newQuantity = itm.quantity + quantity;
                cart.updateItemQuantity(itm.id, newQuantity, apolloClient, function() {
                    (0,_components_Toaster__WEBPACK_IMPORTED_MODULE_8__/* .notifySuccess */ .t5)("Se ha actualizado el carrito con ".concat(quantity, " ").concat(quantity === 1 ? "unidad" : "unidades", " m\xe1s de ").concat(product.name, ", para un total de ").concat(newQuantity, " ").concat(newQuantity === 1 ? "unidad" : "unidades", "."));
                    setInitialQuantity(1);
                });
            }
        }
    }, [
        product,
        cart,
        apolloClient,
        isAuthenticated
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (cart.isItemUpdating(product.productId)) {
            setTimeout(function() {
                return cart.finishUpdatingItem(product.productId);
            }, 2000);
        }
    }, [
        product,
        cart
    ]);
    var isUpdatingCart = cart.isItemUpdating(product.productId);
    var certificationDetailsLink = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        href: certification.uri,
        className: "inline-flex items-center space-x-px text-green-500 hover:text-white cursor-pointer focus:ring-4 rounded-full focus:ring-green-500 focus:ring-opacity-10 focus:bg-green-600 focus:text-white pl-6 pr-4 py-1 hover:bg-green-500",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "font-medium lg:text-lg lg:font-semibold",
                children: "M\xe1s informaci\xf3n"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: "h-5 w-5 text-current",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                    clipRule: "evenodd"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "shadow rounded-lg lg:rounded-xl xl:rounded-2xl overflow-hidden bg-white md:col-span-6 flex ring-1 ring-black ring-opacity-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-stretch lg:flex-col w-full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-40 lg:w-auto bg-gray-50 bg-gradient-to-t from-grady-50 to-white relative py-6 lg:p-8 flex items-start justify-center lg:items-center lg:justify-start lg:px-6 lg:space-x-6 lg:bg-gradient-to-t lg:from-gray-100 lg:to-gray-50",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            href: certification.uri,
                            title: "M\xe1s informaci\xf3n",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                alt: certification.featuredImage.node.alt || certification.featuredImage.node.title,
                                src: certification.featuredImage.node.sourceUrl,
                                className: "h-auto rounded-full relative z-20",
                                width: 160,
                                height: 160
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "hidden lg:flex flex-col space-y-1 lg:space-y-4 flex-1 pr-5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    className: "focus:outline-none",
                                    href: certification.uri,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-xl lg:text-2xl xl:text-3xl",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "lg:tracking-tight font-semibold lg:font-bold xl:font-medium leading-snug",
                                            children: certification.title
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center space-x-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-lg lg:text-xl xl:text-2xl font-normal text-green-500",
                                        children: product.price
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-px w-full hidden lg:block bg-gray-300"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex-1 p-4 md:p-6 lg:p-0 flex flex-col divide-y lg:divide-none space-y-4 lg:space-y-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col space-y-1 lg:space-y-4 lg:p-6 lg:hidden",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    className: "focus:outline-none",
                                    href: certification.uri,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-xl lg:text-2xl xl:text-3xl",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "lg:tracking-tight font-semibold lg:font-bold xl:font-medium leading-snug",
                                            children: certification.title
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center space-x-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-lg lg:text-xl xl:text-2xl font-normal text-green-500",
                                        children: product.price
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex-1 flex flex-col pt-4 space-y-4 lg:py-6 lg:px-10",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-gray-600 text-sm flex-1 leading-relaxed lg:text-lg",
                                    dangerouslySetInnerHTML: {
                                        __html: certification.excerpt
                                    }
                                }),
                                isAuthenticated && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: certificationDetailsLink
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-px w-full hidden lg:block bg-gray-200"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex items-center pt-4 space-x-4 lg:p-6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex-1 flex items-center justify-end",
                                children: isAuthenticated ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center space-x-2 lg:space-x-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ShoppingCart__WEBPACK_IMPORTED_MODULE_7__/* .QuantitySelector */ .cw, {
                                            disable: isUpdatingCart,
                                            initialQuantity: initialQuantity,
                                            onQuantityUpdated: function(qty) {
                                                return setItemQuantity(qty);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("rounded-full bg-green-500 px-5 lg:px-8 py-1 inline-flex relative items-center font-medium text-white leading-6 hover:bg-green-600 focus:ring-4 focus:ring-green-200 focus:bg-green-600 lg:py-2 lg:text-lg lg:leading-7 lg:font-semibold", isUpdatingCart && "pointer-events-none opacity-50"),
                                            onClick: function() {
                                                return onAddItemToCartClick(qty);
                                            },
                                            type: "button",
                                            children: [
                                                isUpdatingCart && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute inset-0 justify-center items-center flex text-white",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LoadingIndicator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            color: "text-white"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(isUpdatingCart && "invisible"),
                                                    children: "A\xf1adir al carrito"
                                                })
                                            ]
                                        })
                                    ]
                                }) : certificationDetailsLink
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function CertificationsPageFinal(param) {
    var isAuthenticated = param.isAuthenticated, apolloClient = param.apolloClient;
    var ref = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_15__/* .useQuery */ .a)((_graphql_queries_certificationProductsListing_graphql__WEBPACK_IMPORTED_MODULE_11___default()), {
        client: apolloClient,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "cache-first"
    }), loading = ref.loading, error = ref.error, data = ref.data, networkStatus = ref.networkStatus;
    var isRefetching = networkStatus === _apollo_client__WEBPACK_IMPORTED_MODULE_16__/* .NetworkStatus.refetch */ .I.refetch;
    if (loading && !isRefetching) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CertificationsPageSkeleton, {});
    }
    if (error) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CertificationsPageError, {
            error: error
        });
    }
    var _certifications = data.certifications, certifications = _certifications.nodes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex w-full py-10 lg:pb-20 relative bg-gray-100 from-gray-100 to-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: "relative z-20 space-y-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "text-3xl lg:text-5xl font-display font-extrabold tracking-tight",
                        children: "Certificaciones"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-12 gap-10",
                    children: certifications.map(function(certification) {
                        var product = certification.info.product;
                        if (product === null) {
                            return null;
                        }
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CertificationsPageItem, {
                            certification: certification,
                            product: product,
                            isAuthenticated: isAuthenticated,
                            apolloClient: apolloClient
                        }, certification.id);
                    })
                })
            ]
        })
    });
}
function CertificationsPage(_param) {
    var loadingCurrentUser = _param.loadingCurrentUser, user = _param.user, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_param, [
        "loadingCurrentUser",
        "user"
    ]);
    if (loadingCurrentUser) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CertificationsPageSkeleton, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CertificationsPageFinal, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        apolloClient: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_9__/* .createApolloClient */ .nl)(null, (user === null || user === void 0 ? void 0 : user.accessToken) || null)
    }, rest));
}
/* harmony default export */ __webpack_exports__["default"] = ((0,_components_ProtectedPage__WEBPACK_IMPORTED_MODULE_10__/* .withAuthenticatedUser */ .c)(CertificationsPage, {
    doNotRedirectToLogin: true
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [268,774,888,179], function() { return __webpack_exec__(92711); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);